// Shared dark-theme tokens for the mobile app shell.
export const M = {
  page: "bg-[#0C1017] min-h-screen text-slate-100",
  card: "bg-[#161B22] border border-white/10 rounded-xl",
  section: "bg-[#1A1F27] border-white/10",
  divide: "border-white/10",
  chip: "bg-white/5 text-slate-300",
  chipOn: "bg-[#C8000F] text-white",
  info: "bg-[#12233B] border border-[#1E3A5F] text-[#9CC4EE]",
};

export const mStatusPill = (s) =>
  s === "open" ? "bg-[#183A22] text-[#6FCF5A]"
  : s === "closed" ? "bg-[#3A1A1E] text-[#F26D77]"
  : "bg-[#3A2E12] text-[#E8B54B]";

export const mStatusLabel = (s) => (s === "open" ? "OPEN" : s === "closed" ? "CLOSED" : "SOON");
